"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOnAccountPayment = exports.processCompletedPayment = void 0;
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
const lodash_keyby_1 = __importDefault(require("lodash.keyby"));
/**
 * Update order to Complete
 * @param order Order
 */
function updateOrderAndItemsStatusToComplete(order, orderStatus, itemStatus) {
    order.status = orderStatus;
    order.orderItems.forEach(item => {
        var _a;
        if (item.status !== domain_1.OrderItemStatus.VOID &&
            item.status !== domain_1.OrderItemStatus.CANCELLED &&
            item.status !== domain_1.OrderItemStatus.REFUNDED &&
            item.status !== domain_1.OrderItemStatus.TRANSFERRED) {
            item.status = itemStatus;
            (_a = item.comboItems) === null || _a === void 0 ? void 0 : _a.forEach(comboItem => {
                comboItem.status = itemStatus;
            });
        }
    });
}
function mergeOnAccountPaymentObject(order) {
    const onAccountPayments = order.payments.filter(payment => {
        var _a;
        return ((_a = payment.paymentType) === null || _a === void 0 ? void 0 : _a.name) === domain_1.OrderAction.ON_ACCOUNT_PAYMENT_TYPE &&
            payment.status === domain_1.OrderPaymentStatus.PENDING;
    });
    const onAccountPayment = onAccountPayments.reduce((accum, payment) => {
        var _a, _b, _c, _d;
        return {
            ...payment,
            customer: (_a = payment.customer) !== null && _a !== void 0 ? _a : accum.customer,
            amount: (0, utils_1.sumDecimals)([(_b = accum.amount) !== null && _b !== void 0 ? _b : 0, payment.amount]),
            tendered: (0, utils_1.sumDecimals)([(_c = accum.tendered) !== null && _c !== void 0 ? _c : 0, payment.tendered]),
            ...(((_d = accum === null || accum === void 0 ? void 0 : accum.orderItemIds) === null || _d === void 0 ? void 0 : _d.length) && {
                orderItemIds: [...accum.orderItemIds, ...payment.orderItemIds],
            }),
        };
    }, {});
    return [
        ...order.payments.filter(payment => payment.paymentType.name !== domain_1.OrderAction.ON_ACCOUNT_PAYMENT_TYPE),
        onAccountPayment,
    ];
}
function processCompletedPayment(input) {
    var _a, _b;
    const { order, deviceId, paidAmount, roundOffDifference, paymentSurcharge = 0, paymentTip: paymentTipProp = 0, } = input;
    const isOolioStoreOrder = ((_a = order.integrationInfo) === null || _a === void 0 ? void 0 : _a.app) === domain_1.IntegrationApps.OOLIO_STORE &&
        deviceId == 'OOLIO_STORE';
    // FIXME: For online store amount due already contains tip.
    // Removing it in that case. Can improve it further later.
    const paymentTip = (order === null || order === void 0 ? void 0 : order.tip) && isOolioStoreOrder ? 0 : paymentTipProp;
    if (order.amountDue > 0) {
        order.amountDue = (0, utils_1.limitDecimalCount)((0, utils_1.sumDecimals)([
            (0, utils_1.sumDecimals)([order.amountDue, roundOffDifference || 0]),
            -paidAmount,
            paymentSurcharge,
            paymentTip,
        ]));
    }
    else if (order.amountDue === undefined) {
        order.amountDue = (0, utils_1.limitDecimalCount)((0, utils_1.sumDecimals)([
            (0, utils_1.sumDecimals)([order.totalPaymentAmount, roundOffDifference || 0]),
            -paidAmount,
            paymentSurcharge,
            paymentTip,
        ]));
    }
    else {
        order.amountDue = 0;
    }
    order.roundingAmount = (_b = order === null || order === void 0 ? void 0 : order.payments) === null || _b === void 0 ? void 0 : _b.filter(payment => (0, utils_1.isCompletedOrRefundedPayment)(payment.status)).reduce((prev, cur) => (0, utils_1.sumDecimals)([prev, cur.roundOffDifference]), 0);
    order.surchargeAmount = (0, utils_1.sumDecimals)([
        order.surchargeAmount || 0,
        paymentSurcharge,
    ]);
    order.totalPaymentAmount = (0, utils_1.sumDecimals)([
        order.totalPaymentAmount,
        paymentSurcharge,
        paymentTip,
    ]);
    order.tip = (0, utils_1.getTipsFromPayments)(order.payments) || (order === null || order === void 0 ? void 0 : order.tip) || 0;
    if (order.amountDue <= 0) {
        const updatedOrderStatus = order.refundOf
            ? domain_1.OrderStatus.REFUNDED
            : domain_1.OrderStatus.COMPLETED;
        const updatedOrderItemStatus = order.refundOf
            ? domain_1.OrderItemStatus.REFUNDED
            : domain_1.OrderItemStatus.COMPLETED;
        const isOrderOnHold = order.status == domain_1.OrderStatus.ON_HOLD;
        // update payment status of item to COMPLETED
        order.orderItems = order.orderItems.map(item => ({
            ...item,
            paymentStatus: domain_1.OrderPaymentStatus.COMPLETE,
        }));
        // In case of Oolio store order, order status is not updated after payment is done
        // In case of order ON HOLD also we DO NOT update status of order to complete
        // In case of prepayment through reservation also we DO NOT update status of order to complete
        if (!isOolioStoreOrder && !isOrderOnHold && !input.isPrePayment) {
            updateOrderAndItemsStatusToComplete(order, updatedOrderStatus, updatedOrderItemStatus);
            const tables = (0, utils_1.getTablesFromOrder)(order);
            const updatedTables = tables.map(table => ({
                ...table,
                status: domain_1.TableStatus.AVAILABLE,
            }));
            order.tables = updatedTables;
            order.table = updatedTables[0];
        }
    }
}
exports.processCompletedPayment = processCompletedPayment;
// Update the on account payment status when customer pay back
function updateOnAccountPayment(paymentStatus, amountToUpdate, order, roundOffDifference) {
    var _a;
    if (paymentStatus === domain_1.OrderPaymentStatus.COMPLETE) {
        const onAccountPayment = order.payments.find(payment => payment.paymentType.name === domain_1.OrderAction.ON_ACCOUNT_PAYMENT_TYPE &&
            payment.status !== domain_1.OrderPaymentStatus.COMPLETE);
        if (onAccountPayment) {
            onAccountPayment.tendered = (0, utils_1.limitDecimalCount)((0, utils_1.sumDecimals)([
                (_a = onAccountPayment.tendered) !== null && _a !== void 0 ? _a : 0,
                amountToUpdate,
                -(roundOffDifference !== null && roundOffDifference !== void 0 ? roundOffDifference : roundOffDifference),
            ]));
            onAccountPayment.status =
                onAccountPayment.amount <= onAccountPayment.tendered
                    ? domain_1.OrderPaymentStatus.COMPLETE
                    : domain_1.OrderPaymentStatus.PART_PAID;
            const filteredPayments = onAccountPayment.status === domain_1.OrderPaymentStatus.COMPLETE
                ? order.payments.filter(p => p.paymentType.name !== domain_1.DefaultPaymentTypes.ON_ACCOUNT)
                : order.payments;
            order.payments = filteredPayments;
        }
    }
}
exports.updateOnAccountPayment = updateOnAccountPayment;
/**
 * Set status of order to COMPLETED
 * Can only be done when the order is in IN_PROGRESS status
 * @param event of type OrderPayment
 * @param prevState
 */
function default_1(event, prevState = {}) {
    var _a, _b, _c;
    const order = prevState;
    const paidAmount = (0, utils_1.limitDecimalCount)((0, utils_1.sumDecimals)([event.tendered, -event.change]));
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    /*
      payment status in payment object for on account is pending/Unpaid if paid via On Account.
      We're going to settle this amount later on from customer screen
    */
    const paymentStatus = event.onAccount
        ? domain_1.OrderPaymentStatus.PENDING
        : event.paymentStatus || domain_1.OrderPaymentStatus.COMPLETE;
    const isCompletedOrRefundedStatus = (0, utils_1.isCompletedOrRefundedPayment)(paymentStatus);
    order.payments = order.payments || [];
    order.payments.push({
        id: event.id,
        paymentType: { id: event.paymentTypeId, name: event.paymentTypeName },
        paymentReceipt: event.paymentReceipt,
        amount: paidAmount,
        tendered: event.onAccount ? 0 : event.tendered || 0,
        tip: event.tip || 0,
        roundOffDifference: event.roundOffDifference || 0,
        status: paymentStatus,
        isPrePayment: !!event.isPrePayment,
        ...((event === null || event === void 0 ? void 0 : event.cardType) && {
            cardType: event === null || event === void 0 ? void 0 : event.cardType,
        }),
        ...(event.paymentRequestId && {
            paymentRequestId: event.paymentRequestId,
            updatedByDeviceId: event.deviceId,
        }),
        ...(event.paymentTransactionRef && {
            paymentTransactionRef: event.paymentTransactionRef,
        }),
        ...(isCompletedOrRefundedStatus && {
            paymentCompletedAt: new Date(event.timestamp || Date.now()).toISOString(),
        }),
        ...((event === null || event === void 0 ? void 0 : event.customer) && {
            customer: { id: event.customer },
        }),
        ...(((_a = event === null || event === void 0 ? void 0 : event.orderItemIds) === null || _a === void 0 ? void 0 : _a.length) && {
            orderItemIds: event.orderItemIds,
        }),
        ...((event === null || event === void 0 ? void 0 : event.splitPaymentBy) && {
            splitPaymentBy: event.splitPaymentBy,
        }),
        ...((event === null || event === void 0 ? void 0 : event.paymentSurcharge) && {
            paymentSurcharge: event.paymentSurcharge,
        }),
        ...((event === null || event === void 0 ? void 0 : event.paymentBreakdown) && {
            paymentBreakdown: event.paymentBreakdown,
        }),
    });
    const processingOrderItems = ((_b = event === null || event === void 0 ? void 0 : event.paymentBreakdown) === null || _b === void 0 ? void 0 : _b.items) || [];
    if (processingOrderItems.length) {
        const processingOrderItemMaps = (0, lodash_keyby_1.default)(processingOrderItems, 'orderItemId');
        order.orderItems.forEach((item) => {
            const paymentInfo = processingOrderItemMaps[item.id];
            if (paymentInfo && paymentInfo.quantityPaid == item.quantity) {
                item.paymentStatus = paymentStatus;
            }
        });
    }
    if (event.onAccount || isCompletedOrRefundedStatus) {
        processCompletedPayment({
            order,
            deviceId: event === null || event === void 0 ? void 0 : event.deviceId,
            paidAmount,
            roundOffDifference: event === null || event === void 0 ? void 0 : event.roundOffDifference,
            ...(event.refundOrder && { paymentSurcharge: event.paymentSurcharge }),
            isPrePayment: event.isPrePayment,
        });
    }
    if (event.onAccount) {
        order.totalOnAccountAmount = (0, utils_1.sumDecimals)([
            (_c = order.totalOnAccountAmount) !== null && _c !== void 0 ? _c : 0,
            paidAmount,
        ]);
        order.payments = mergeOnAccountPaymentObject(order);
    }
    if (order.amountDue === 0 && order.status === domain_1.OrderStatus.ON_HOLD) {
        // for on hold orders when we pay completly the items should be shown as paid
        order.orderItems.forEach((item) => {
            item.paymentStatus = domain_1.OrderPaymentStatus.COMPLETE;
        });
    }
    if (event.isOnAccountClearance) {
        updateOnAccountPayment(paymentStatus, paidAmount, order, event.roundOffDifference);
    }
    const onAccountPayment = (0, utils_1.getOnAccountPayment)(order.payments);
    if (event.refundType)
        order.refundType = event.refundType;
    return {
        ...order,
        ...(onAccountPayment &&
            onAccountPayment.status !== domain_1.OrderPaymentStatus.COMPLETE &&
            !order.amountDue &&
            !event.refundOrder && { status: domain_1.OrderStatus.ON_ACCOUNT }),
    };
}
exports.default = default_1;
//# sourceMappingURL=orderPayment.js.map